module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAhUlEQVRYhe3RsQ3CUAwGYQ+QJtsgMU8q1qChYwma7JSCRTiagEC8dJaeI+6T3J9+R0iSpAqAA3ABbsC83tS76wtwBh409G57A46twIqh10bfHViqhbacenf9KP3uiAhgAMaNRcf1ht6dWy+vt66hfxv6Ujruk6HZDM1maDZDs+0mVJKkFE/3vCPhIQMPuAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico-facebook.png
// module id = kS7v
// module chunks = 1